// extracted by mini-css-extract-plugin
module.exports = {"main":"NotificationLayout-module__main--2md1r"};